
import Timer from "../../../assets/outline/Timer.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TimerIcon({ className, dataTestid = "TimerIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Timer data-testid={dataTestid} className={classes} {...rest} />
  );
}
